import GAWrapper from './GAWrapper';
export default GAWrapper;